export default __webpack_public_path__ + "static/media/landin-blockimg11.1e5230bb.png";